module.exports = __webpack_public_path__ + "static/media/qr_wx.b9b476bb.png";